var render = function render(){var _vm=this,_c=_vm._self._c;return _c('reportFormWrap',{ref:"reportFormWrap",attrs:{"reportid":_vm.reportid,"orderMenu":_vm.orderMenu,"settingCols":_vm.settingCols,"getFiltersParams":_vm.getFiltersParams,"reportFormUrl":_vm.reportFormUrl}},[_c('FiltersBox',{ref:"filters",attrs:{"slot":"filters"},on:{"inputEnter":_vm.inputEnter},slot:"filters"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }